import 'view/css/print-preview.css';

import { useState, useRef } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog, faMinus, faPlus, faPrint } from '@fortawesome/free-solid-svg-icons';

import API from 'service/api';
import Util, { printContent } from 'service/util';
import TKCache from 'service/cache';
import { compressImage, extractBase64 } from 'service/image';

import PopMessage from 'component/pop-msg/PopMessage';
import ModalScreen from 'component/ModalScreen';

import { A4PrintPage, A4PreviewPage } from './A4Page';

const translate = (key) => {
  let val = TKCache.Translate?.[key];
  return val || key;
}

const AdjFieldModal = ({company, printId, config}) =>
{
  const ref_file = useRef();
  const [__refresher, forceRender] = useState(false);

  const _createSetter = (field, key) => {
    return e => {
      field[key] = parseFloat(e.target.value);
      forceRender(!__refresher);
    };
  }

  const updateSplit = (e) => { config.split = parseInt(e.target.value); }

  const readBackgroundImageAsync = async () =>
  {
    let file = ref_file.current.files[0];
    if (!file) {
      return null;
    }

    return await new Promise((resolve, reject) =>
    {
      let reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result);
      }
      reader.readAsDataURL(file);
    })
    .then(d => compressImage(d, 0.75))
    .then(extractBase64);
  }

  const savePrintConfig = async () =>
  {
    let background = await readBackgroundImageAsync();
    let cfg = { ...config, background };
    let dto = { [`${company}@${printId}`]: cfg };
    API.editPrintConfig(dto).then(resp => {
      if (!resp.success)
      {
        PopMessage.show('無法更新列印設定。', '失敗', 'danger');
      } else {
        PopMessage.show('已儲存列印設定。', '成功', 'success');
      }

    });
  }

  return (<>
    <div className="box">
      <h4 className="box-head">設定</h4>
      <div className="box-body">
        <label className="field">
          <strong>公司</strong>
          <span>{ Util.getCompanyName(company) }</span>
        </label>
        <label className="field">
          <strong>分拆</strong>
          <span>
            <input type="number" min="1" max="3"
                   value={config.split}
                   onChange={updateSplit} />
          </span>
        </label>
        <label className="field">
          <strong>背景圖片</strong>
          <span>
            <input type="file" ref={ref_file} />
          </span>
        </label>
      </div>
    </div>
    <div className="box">
      <h4 className="box-head">內容</h4>
      <div className="box-body">
        <table className="config-list">
          <thead>
            <tr>
              <th>Key</th>
              <th>位置 X</th>
              <th>位置 Y</th>
              <th>字體大小</th>
            </tr>
          </thead>
          <tbody>
            { config.fields.map(f =>
              <tr key={f.key}>
                <th>{ translate(f.key) }</th>
                <td><input type="number" value={f.x}        onChange={_createSetter(f, 'x')}        /></td>
                <td><input type="number" value={f.y}        onChange={_createSetter(f, 'y')}        /></td>
                <td><input type="number" value={f.fontSize} onChange={_createSetter(f, 'fontSize')} /></td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
    <div className="row btn-grp">
      <button className="btn red" onClick={savePrintConfig}>儲存</button>
    </div>
  </>);
}

const PrintPreview = ({items, company, printId, config, addOn, addSignal, ...props}) =>
{
  const [modal, setModal] = useState(null);
  const [dp_throttle, setDisplayThrottle] = useState(15);
  const [preview_size, setPreviewSize] = useState(9);

  const zoomIn  = () => { setPreviewSize( Math.min(14, +1+preview_size) ); }
  const zoomOut = () => { setPreviewSize( Math.max( 0, -1+preview_size) ); }
  const onScroll = (e) =>
  {
    // progressive loading
    if (dp_throttle > pages.length) return;
    if (Math.ceil(10+e.target.scrollTop + e.target.clientHeight) >= e.target.scrollHeight) {
      setDisplayThrottle(20 + dp_throttle);
    }
  }

  const pages = items.reduce((r, x) => {
    if ( r[r.length - 1]?.length >= (config?.split||1) ) r.push([]);
    let arr = r[r.length - 1];
    arr.push(x);
    arr.key = `${arr.key||''}//${x.key}`;
    return r;
  }, [[]]);

  const print = () =>
  {
    let dom = (<>{ pages.map((x,i) =>
      <A4PrintPage key={i} items={x} config={config} addOn={addOn} addSignal={addSignal}/>
    )}</>);
    printContent(dom, { css: ['print-bill.css'] });
  } // end void print()

  const showConfigModal = () =>
  {
    setModal(<AdjFieldModal company={company} printId={printId} config={config} />);
  }

  return (
    <div id="print-preview" className={`sz-${preview_size}`}>
      <div className="body" onScroll={onScroll}>
        { pages.slice(0, dp_throttle).map((p,i) =>
          <A4PreviewPage key={p.key} config={config}
            items={p} pageNumber={`第 ${1+i} 頁`} addOn={addOn}
            addSignal={addSignal}
          />
        )}
      </div>
      <div className="afloat-tool">
        <button className="tool-btn zoom-in" onClick={zoomIn}>
          <FontAwesomeIcon icon={faPlus} />
        </button>
        <button className="tool-btn zoom-out" onClick={zoomOut}>
          <FontAwesomeIcon icon={faMinus} />
        </button>
        <button className="tool-btn print" onClick={print}>
          <FontAwesomeIcon icon={faPrint} />
        </button>
        <button className="tool-btn config" onClick={showConfigModal}>
          <FontAwesomeIcon icon={faCog} />
        </button>
      </div>
      <div className="afloat-count">
        <span>{ Math.min(pages.length, dp_throttle) } / { pages.length }</span>
      </div>
      <ModalScreen show={!!modal} title="調整印高" onClose={e=>setModal(null)}>{ modal }</ModalScreen>
    </div>
  );

}


export default PrintPreview;